<template>
  <div class="wrapper login-wrapper">
    <!-- 调试埋点 -->
    <div v-if="isShowBuriedPoint">
      <div @click="showaddPlgin=!showaddPlgin" style='position: absolute;z-index: 9;width:30px;height:30px;'></div>
      <div style='display:flex;position: absolute;z-index: 10;width:80%' v-if="showaddPlgin">
        <el-input :style="{width:'560px'}" v-model="addPlginValue"></el-input>
        <el-button @click="addPlgin">确认埋点</el-button>
      </div>
    </div>
    <!-- ===========调试埋点 相应参数和方法结束后可删除-->
    <div class="loading" v-if="transition||HQ">
      <img src="../assets/images/common/loading1.gif" alt="">
    </div>
    <div v-else class="content"  :class="{'customLogin':customLogin}">
      <div class="right">
        <div class="login-box">
          <div class="swipeWrapper"  @click="onSwiperChange">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide><img src="../../static/img/customLogin/swiper1_1.jpg"></swiper-slide>
              <swiper-slide><img src="../../static/img/customLogin/swiper2.jpg"></swiper-slide>
              <swiper-slide><img src="../../static/img/customLogin/swiper3.jpg"></swiper-slide>
              <swiper-slide><img src="../../static/img/customLogin/swiper4.jpg"></swiper-slide>
              <div class="swiper-pagination"  slot="pagination"></div>
            </swiper>
            <!-- <div class="newsWrap">
              <span class="nt">最新资讯</span>
              <span class="circle"><label></label></span>
              <p style="cursor: pointer" @click="goNews" v-if="news.title">{{news.title}}<label class="newsSplitLine"></label></p>
            </div> -->
          </div>
          <div class="link" v-if="userMenu.indexOf('serviceProtocol')>-1">
            <a v-show="systemConfig.serviceProtocolUrl" :href=systemConfig.serviceProtocolUrl  id="use1" target="_blank">《服务协议》</a>
            <a v-show="!systemConfig.serviceProtocolUrl" href="./term_of_use"  id="use" target="_blank">《服务协议》</a>
            <span></span>
          </div>
          <div class="login-form" v-show="!isScan&&!isScaned">
            <h3 v-if="systemConfig.logo"><img @click="goLXY" width="236" height="62"  :src="'https://skb-static.lixiaoskb.com/twe/image/'+ systemConfig.logo" alt="" style="margin:11px 0 11px -10px"></h3>
            <h3 v-else><img   @click="goLXY" width="236" height="62" src="../assets/sokelogo.png" alt="" style="margin:11px 0 11px -10px"></h3>
            <div class="title" :class="{'speTitle':!systemConfig.enableSmsLogin}">
              <span :class="{'active':loginType===1}" @click="loginType=1">密码登录</span>
              <span  class="titleDash"  v-if='systemConfig.enableSmsLogin'>|</span>
              <span :class="{'active':loginType===2}"  v-if='systemConfig.enableSmsLogin' @click="loginType=2">短信登录</span>
            </div>
            <div class="ms-login" v-if="loginType===1">
              <el-form :model="userInfo" :rules="rules" ref="userInfo" class="demo-ruleForm">
                <el-form-item prop="userName" :error="errMsg === '您输入的账号或密码不正确,请重新输入'? ' ': null">
                  <div class="user">
                    <i></i>
                    <el-input @keyup.enter.native="submit('userInfo')" type="text" @change="errMsg = ''" v-model="userInfo.userName" auto-complete="off" placeholder="邮箱/手机号码" size="large"></el-input>
                  </div>
                </el-form-item>
                <el-form-item prop="pwd" :error="errMsg === '您输入的账号或密码不正确,请重新输入'? ' ': null">
                  <div class="pwd">
                    <i></i>
                    <el-input @keyup.enter.native="submit('userInfo')" type="password" @change="errMsg = ''" v-model="userInfo.pwd" auto-complete="off" placeholder="密码" size="large"></el-input>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="ms-login" style="position: relative" v-else id="msgVerify">
              <el-form :model="userInfo2" :rules="rules2" ref="userInfo2" class="demo-ruleForm">
                <el-form-item prop="telephone">
                  <div class="user iphone" style="position: relative">
                    <i></i>
                    <el-input type="text" v-model.trim="userInfo2.telephone" :maxlength="11" auto-complete="off" placeholder="请输入手机号码" size="large"></el-input>
                  </div>
                </el-form-item>

                <el-form-item prop="imgVerifyCode">
                  <div class="pwd verifyCode" style="position: relative">
                    <i></i>
                    <el-input type="text" name="imgVerify" style="display: none" v-model="imgVerifyCode2"></el-input><!--解决自动填充问题-->
                    <el-input type="text" ref='imgVerify' name="verify" @focus="imgVerifyCode2=''" v-model="userInfo2.imgVerifyCode" auto-complete="off" placeholder="请输入图片验证码" width="240px"></el-input>
                  </div>
                  <div class="verifyButton imgVerify" v-if='imgVerifySrc'><img :src="imgVerifySrc" alt="" @click="getImgVerifyCode()"></div>
                  <div class="verifyButton imgVerify refreshImg" v-else @click="getImgVerifyCode()">
                    <i class="el-icon-refresh"></i>
                    <p>加载超时，请重试</p>
                    <!-- <img :src="imgVerifySrc" alt="" @click="getImgVerifyCode()"> -->
                  </div>
                </el-form-item>

                <el-form-item prop="verifycode">
                  <div class="pwd verifyCode" style="position: relative">
                    <i></i>
                    <el-input type="text" name="verify" style="display: none" v-model="verifycode2"></el-input><!--解决自动填充问题-->
                    <el-input type="text" name="verify" @focus="verifycode2=''" v-model="userInfo2.verifycode" auto-complete="off" placeholder="请输入短信验证码" width="240px"></el-input>
                  </div>
                  <div class="verifyButton" v-if="time===60" @click="userInfo2.imgVerifyCode&&userInfo2.telephone ?checkVeriFy():''"
                      :class="{'disabled':!userInfo2.imgVerifyCode || !userInfo2.telephone}">发送短信验证码</div>
                  <div class="verifyButton timeButton"  v-else> {{time}}s</div>

                </el-form-item>
              </el-form>
            </div>
            <div class="btn"  :style="{'margin-top':loginType===2 ? '40px':'60px'}">
              <button v-if="loginType===1" @click="submit('userInfo')" :disabled="disable">{{buttonMsg}}</button>
              <button v-else @click="msLogin" :disabled="disable">{{buttonMsg}}</button>
            </div>
            <div v-if="errMsg" class="err-msg">{{errMsg}}</div>
            <div class="remember" :style="{'height':loginType===2 ? '18px':''}">
              <el-checkbox v-model="keepName"  v-if="loginType===1">记住我</el-checkbox>
              <el-checkbox v-model="keepPhone"  v-if="loginType===2">记住我</el-checkbox>
              <span v-if="systemConfig.enableSmsLogin">
                <gem-link href="/forgetPassword">忘记密码</gem-link>
              </span>
            </div>
            <div class="speLink"  v-if="userMenu.indexOf('serviceProtocol')>-1"  @click="toService">
              <el-checkbox v-model="checkService"></el-checkbox>
              <strong style="margin-left:8px;font-weight: normal">我已经阅读并同意相关</strong>
              <label style="margin-left: -4px;">《服务协议》</label><span></span>
            </div>
            <div class="goToNew" :class="{'distance-tip':loginType===2}">
              <p>数据/营销版搜客宝</p>
              <div class="goBtn">
                <span class="goLogin" @click="toNewSkb(1)">登录 <label class="speLine1"></label></span>
                <label class="splitLine">|</label>
                <span class="goRegister" @click="toNewSkb(2)">免费注册 <label class="speLine2"></label></span>
              </div>
            </div>
            
          </div>
          <div class="login-form" v-show="isScan">
            <h3 style="margin-bottom: 0;"><img width="180"  height="84" src="../assets/logo.png" alt=""></h3>
            <div id="login_container"></div>
            <div class="scanTitle">
              <img src="../assets/dingtalkLogo.png">
              <span >钉钉扫码登录</span>
            </div>
            <div class="scanFoot"  @click="goIndex">返回首页</div>
          </div>
          <div class="login-form" v-show="isScaned">
            <h3 style="margin-bottom: 0;"><img width="180"  height="84" src="../assets/logo.png" alt=""></h3>
            <p class="loginTitle">请选择登录使用的企业</p>
            <p class="loginCompany" :class="{'selected':check(index)}" v-for="(item,index) in companyList" :key="index" @click="chooseCompanyLogin(index)">{{item.corpName}}</p>
          </div>
        </div>
        <div class="footer">
          <div v-if="systemConfig.icpRecord" class="icp" style="margin-bottom:10px"><a href="https://beian.miit.gov.cn/" target='_blank'>{{systemConfig.icpRecord}}</a></div>
          <div v-else class="icp" style="margin-bottom:10px"><a href="https://beian.miit.gov.cn/" target="_blank">© 2016-2018 上海微问家信息技术有限公司 版权所有 ICP证：沪ICP备14028521号-6</a><img src="../assets/police.png" class="beian_icon"  style="width:10px;height:10px;margin-left:15px;"/><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502017987" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">沪公网安备 31011502017987号</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '../common/user';
import Vue from 'vue';
import config from '../config';
import installPermission from '../common/installPermission';
import verifyWrap from "./global/verifyWrap.vue";
import {
  cookieManager,
  getLoginIndex,
  getUrlParam,
  clearLocalStorage
} from '../common/utils';
import { mapActions,mapState} from 'vuex';
import htmlOptions from '../../config/html';
export default {
  name: 'login',
  data() {
    return {
      showaddPlgin:false,
      addPlginValue:'',//埋点
      disable: false,
      keepName: true,
      keepPhone: true,
      deal: true,
      errMsg: '',
      siteKey1: 'c58fc617035bace404ff814c5b676628',
      siteKey2: '700220890ae2a04eece2ab6d09a5063f', //api
      buttonMsg: '登入系统',
      userInfo: {
        userName: '',
        pwd: ''
      },
      rules: {
        userName: [
          {
            required: true,
            message: '请输入用户名（邮箱/手机号码）',
            trigger: 'blur'
          }
        ],
        pwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      },
      isScan:false,
      isScaned:false,
      goto:'',
      companyList:[],
      companyIndex:'',
      loginTmpCode:'',
      isLogin:false,

      loginType:1,
      isVerified:false,
      verifyParams:{},
      time:60,
      userInfo2:{
        telephone: '',
        verifycode:'',
        imgVerifyCode:'',
      },
      rules2: {
        telephone:[
          {
            required: true,
            validator: this.validatePhone2,
            trigger: 'blur'
          }
        ],
        verifycode:[
          {
            required: true,
            validator: this.validateVerifycode,
            trigger: 'blur'
          }
        ],
        imgVerifyCode:[
          {
            required: true,
            validator: this.validateImgVerify,
            trigger: 'blur'
          }
        ]
      },
      verifycode2:'',
      imgVerifyCode2:'',
      systemConfig: {
        enableSmsLogin: true, //默认可短信登陆以及忘记密码操作
      },
      isLoading: true,
      userMenu:[],

      customLogin: false, //展示skb推广
      checkService:true,
      swiperOption: {  //轮播配置,跟版本相关
        autoplay: {
          delay: 5000, //轮播切换延时
          disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
        },
        speed: 1000,
        loop:true,
        pagination: { //分页器
          el: '.swiper-pagination',
          clickable: true,
        }
      },
      news:{
        title:'',
        id: '',
      },
      imgVerifySrc:null,//图片验证路径
      imgVerifyId:null,//验证id
      isRexImg:true,
      isShowBuriedPoint:false,
    };
  },
  components:{verifyWrap},
  computed: {
    transition() {
      const access_token = getUrlParam('access_token');
      const dingCode = getUrlParam('dingCode');
      const did = getUrlParam('did');
      const code = getUrlParam('code');
      if (access_token ||dingCode||(did&&code) || this.isLoading) {
        return true;
      } else {
        return false;
      }
    },
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  watch:{
    systemConfig(val){
      if(val){
        if(val.title){
          document.title = val.title;
        }
        if(val.foldLogo){
          var link = document.getElementById("indexIcon]") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href =`https://skb-static.lixiaoskb.com/twe/image/${val.foldLogo}`;
          document.getElementsByTagName('head')[0].appendChild(link);
          this.setItem('local', 'foldLogo', val.foldLogo);
        }
        if(val.accessibleMenu){
          this.userMenu = Object.keys(val.accessibleMenu);
        }
        if(val.logo){
          this.setItem('local', 'logo', val.logo);
        }
        if(val.enableAdPromotion){
          this.customLogin = val.enableAdPromotion;
          this.setItem('local', 'customLogin', true);
          this.getNews();
        }
      }
    },
    loginType(val,oldVal){
      if(val!=oldVal && val==2){
        this.getImgVerifyCode();//短信登陆初始化验证码
      }
    }
  },
  async beforeCreate() {
    const redirect = getUrlParam('redirect');
    const from = getUrlParam('from');
    const accessToken = getUrlParam('access_token');
    const did = getUrlParam('did');
    const code = getUrlParam('code');
    const channel = getUrlParam('channel');
    const hasToken = this.getItem('local', 'twe_logged');
    const hasUser = this.getItem('local', 'twe_userInfo');
    if(did&&code){
        userService.login({url:'user/login/digitalCloud',payload:{did:did,code:code,channel:channel}}, this);
        return
    }
    if (accessToken) {
      if (hasToken) {
        if (from == 'verify') {
          clearLocalStorage(undefined, true);
        } else {
          clearLocalStorage();
        }
      }
      console.log('tokenLogin')
      userService.tokenLogin(this, accessToken, redirect);
    } else {
      if (hasUser) {
        const user = JSON.parse(hasUser);
        this.$router.push(getLoginIndex(user.role));
      }
    }
    this.removeItem('local', 'isWebLogin');
    this.removeItem('local', 'logo');
    this.removeItem('local', 'foldLogo');
    this.removeItem('local', 'customLogin');

    //对接非跳转登录需获取登录页配置
    let origin =  window.location.hostname==='localhost'? 'https://test.lixiaoskb.com':this.getOrigin();
    if(!accessToken && ( !hasUser || !hasToken ) ){
      try{
        const resp = await this.apiData('get', 'oem/getCustomConfig', { domain:origin });
        this.systemConfig =  resp;
      }catch(error){
        console.log(error);
      }
    }
    this.isLoading = false;
  },
  async mounted() {
    // dev test环境放开埋点
    if(__VERSION==='sokebao_seo_sandbox' || __VERSION==='sokebao_dev'){
      this.isShowBuriedPoint = true
    }
    this.userInfo.userName = cookieManager.getItem(
      config.cookie.userKey,
      false
    );
    this.userInfo2.telephone = cookieManager.getItem(config.cookie.smsLoginKey)

    this.loginTmpCode = getUrlParam('code');
    let loginRedirect = getUrlParam('loginRedirect');
    const dingCode = getUrlParam('dingCode');
    const corpId = getUrlParam('corpId');
    const did = getUrlParam('did');
    // console.log(dingCode,corpId);
    if(loginRedirect || (window.location.hostname == htmlOptions[__HTMlVERSION].DTSCAN_URL && !this.loginTmpCode && !dingCode)){ //非dt版本跳转至扫码登录页面
      this.isScan = true;
      this.onScan();
    }
    if(dingCode){ //钉钉移动端跳转登录
      this.dtLogin({
        code:dingCode,
        corpId:corpId,
        isWebLogin:true
      })
    }
    if(this.loginTmpCode&&!did){ //钉钉扫码登陆获取公司列表
      this.isScaned=true;
      try{
        const resp = await this.apiData('get', 'v1/dingtalk/selectCompanys', {
          scanAuthCode:this.loginTmpCode
        });
        this.companyList = resp.companys;
        this.companyIndex = 0;
      }catch(error){
        this.isScaned=false;
        this.isScan = true;
        this.$message.error(this.errorCode[error.error_code]);
        this.onScan();
      }
    }
    // 调试代码
    this.addPlginValue = window.sessionStorage.getItem('addPlginValue');
    if(this.addPlginValue){
        this.addPlgin();
    }
  },
  methods: {
    ...mapActions(['fetchAccount','getBroadCast']),

    //获取新闻
    async getNews(){
      let url = htmlOptions[__HTMlVERSION].cmsHost+'/api/blogs.json';
      let newsList = [];
      try{
        //newsList = await this.getNewsData('get',url,{ page:1, per:1, website_type:'lixiao_website'});
      }catch(err){
        console.log(err);
      }
      if(newsList[0]){
        this.news = newsList[0];
      }
    },
    //跳转到新闻详情页
    goNews(){
      if(!this.news || !this.news.id){return;}
      let url = htmlOptions[__HTMlVERSION].lxyHost+'/news-detail/'+this.news.id;
      window.open(url,'_blank');
    },
    //点击轮播跳转推广页
    onSwiperChange(e){
      let target = e.target;
      if(target && target.nodeName==='IMG'){
        let index = this.swiper.activeIndex;
        let url = index<4 ?'https://www.lixiaoyun.com/lixiaoskb':'https://www.lixiaoyun.com/cooperation';
        window.open(url,'_blank');
      }
    },
    //跳转新搜客宝
    toNewSkb(index){
      let url = index===1 ?htmlOptions[__HTMlVERSION].newSkbLoginUrl: htmlOptions[__HTMlVERSION].newSkbRegistUrl;
      window.open(url,'_blank');
    },
    //跳转服务协议
    toService(e){
      let url = '';
      let target = e.target;
      if(target && target.nodeName!=='STRONG'&&target.nodeName!=='LABEL'){
        return;
      }
      if(this.systemConfig.serviceProtocolUrl){
        url = this.systemConfig.serviceProtocolUrl
      }else{
        url =this.getOrigin()+'/term_of_use';
      }
      window.open(url,'_blank');
    },
      //跳转励销云官网
    goLXY(){
      if(this.customLogin){
        window.open("https://www.lixiaoyun.com/lixiaoskb" ,'_blank');
      }
    },

    goIndex(){
      window.location.href = "https://"+htmlOptions[__HTMlVERSION].MAIN_URL;
    },
    submit(formName) {
      if(!this.checkService){
        this.$message.error('请勾选同意下方服务协议');
        return;
      }
      let [userName, pwd] = [
        this.userInfo.userName.trim(),
        this.userInfo.pwd.trim()
      ];
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.deal) {
            this.$message.error('请先同意服务协议');
          } else {
            const payload = {
              username: userName,
              password: pwd
            };
            this.disable = true;
            this.buttonMsg = '登录中……';
            userService.login({url:'user/login',payload:payload}, this);
          }
        } else {
          return false;
        }
      });
    },
    /*构建二维码*/
    onScan(){
      if(window.location.hostname !== htmlOptions[__HTMlVERSION].DTSCAN_URL){ //扫码登录需跳转到dt版本
        window.location.href = "https://"+htmlOptions[__HTMlVERSION].DTSCAN_URL+"/login?loginRedirect=Redirect";
        return ;
      }
      let url =  htmlOptions[__HTMlVERSION].REDIRECT_URL;
      let appid =  htmlOptions[__HTMlVERSION].APP_ID;
      this.goto = "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid="+appid+"&response_type=code&scope=snsapi_login&state=STATE&redirect_uri="+url;
      var obj = DDLogin({
        id:"login_container",
        goto:encodeURIComponent(this.goto),
        style: "border:none;background-color:#FFFFFF;",
        width : "365",
        height: "315"
      });
      let that = this;
      var hanndleMessage = function (event) {
        var origin = event.origin;
        if( origin == "https://login.dingtalk.com" ) { //判断是否来自ddLogin扫码事件。
          var loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          window.location.href = that.goto+'&loginTmpCode='+loginTmpCode;
        }
         };
      if(typeof window.addEventListener != 'undefined'){
        window.addEventListener('message', hanndleMessage, false);
      }else if (typeof window.attachEvent != 'undefined'){
        window.attachEvent('onmessage', hanndleMessage);
      }
      this.isScan=true
    },
    check(index){
      if(index===this.companyIndex){
        return true;
      }else{
        return false;
      }
    },
    /*选择公司登录*/
    async chooseCompanyLogin(index){
      this.companyIndex = index;
      this.dtLogin({
        scanAuthCode:this.loginTmpCode,
        corpId:this.companyList[index].corpId,
        isWebLogin:false
      })
    },
    async dtLogin (data){
      if(!this.isLogin){
        this.isLogin = true;
        this.setItem('local', 'isWebLogin', data.isWebLogin);
        try{
          const resp = await this.apiData('post', 'v1/dingtalk/login',data);
          // console.log(resp)
          this.setItem('local', 'twe_logged', resp.token);
          if(resp.isDtAppLogin){
            this.setItem('session', 'isDtAppLogin', resp.isDtAppLogin);
          }
          const ret = await this.fetchAccount();
          this.removeItem('local', 'closeBroad');
          this.getBroadCast();
          this.RegistCall();
          installPermission(Vue, ret);
          window.sa.login(resp.userid);
          this.$store.commit('setClickNum', {
            clickcontact_volume: resp.clickcontact_volume,
            clickedContacts: resp.clickedContacts
          });
          let bigFirst = false;
          if (resp.role == 'bigcustomer'){
            let totalAccount = resp.accountCountInfo.totalMain+resp.accountCountInfo.totalSub;
            let reMainAccount = resp.accountCountInfo.remainMain + resp.accountCountInfo.remainSub;
            bigFirst = (totalAccount==reMainAccount)?true:false;
          }
          if((resp.sequence === 1 && resp.role !== 'bigcustomer') || bigFirst){ // 首次登陆展示提示
            let params = {
              name: 'dingTalk',
              userInfo: resp
            };
            // console.log(params);
            this.$router.push({
              path: '/search',
              name:'search',
              query: params
            });
          }
          else{
            this.$router.push({
              path: getLoginIndex(resp.role)
            });
          }
        }catch(error){
          // this.$message.error(JSON.stringify(error))
          if (error.error_code === 1303) {// 未添加该用户
            let params = {
              name: 'dingTalk',
              disable: true,
              userInfo: JSON.stringify(error.data)
            };
            this.$router.push({
              path: '/loginerror',
              name: 'loginerror',
              query: params
            })
          } else if (error.error_code === 6016 || error.error_code === 6017) {// 禁用
            let params = {
              name: 'dingTalk',
              expired: true,
              userInfo: JSON.stringify(error.data)
            };
            this.$router.push({
              path: '/loginerror',
              name: 'loginerror',
              query: params
            })
          }else if(error.error_code === 1000){// 过期
            this.setItem('local', 'expired_logged', error.data.token);
            this.setItem('session', 'expiredUserInfo', JSON.stringify(error.data));
            let params = {
              name: 'dingTalk',
              userInfo: JSON.stringify(error.data)
            };
            this.$router.push({
              path: '/loginerror',
              name: 'loginerror',
              query: params
            })
          }
          else{
            this.$message.error(this.errorCode[error.error_code]);
            // this.$router.push('/login');
            this.isScaned = false;
          }
        }
        this.isLogin = false;
      }
    },

    // 获取图片验证码
    async getImgVerifyCode(){
      try {
        let result = await this.apiData('get', 'user/getCaptcha');
        this.imgVerifySrc = result.imgBase64;
        this.imgVerifyId = result.uuid;
      } catch (error) {
        this.$message.error(error.message_local ? error.message_local : this.errorCode[error.error_code]);
      }
    },

    //获取短信验证码
    checkVeriFy(){
      this.$refs.userInfo2.validateField('telephone', valid => {
        // if(!valid){
        //   this.$refs.verifyWrap.createCaptcha()
        // }
        if(!valid){
           this.sendMsg() 
        }
      });
    },

    onCaptchaSuccess (ticket) {
      this.sendMsg(ticket)
      this.isVerified = true
    },

    async sendMsg(ticket) {
//       try {
//         await this.apiData('post', 'user/sendSMS', {
//           mobile:this.userInfo2.telephone,
//           scene:'login',
//           ticket
//         });
//         this.$message.success('发送成功！');
//         this.countDown();
//       } catch (error) {
//         if(error.error_code===6118 && error.message_local){
//           this.time = parseInt(error.message_local);
//           this.countDown();
//         }else{
//           this.$message.error(error.message_local ? error.message_local : this.errorCode[error.error_code]);
// //          this.$refs.verifyWrap.reload();
//         }
//       }
       try { 
          await this.apiData('post', 'user/sendSMS', {
            mobile:this.userInfo2.telephone,
            scene:'login',
            captchaId:this.imgVerifyId,
            captchaCode:this.userInfo2.imgVerifyCode
          });
          this.isRexImg = true;
          this.$message.success('发送成功！');
          this.countDown();
        } catch (error) {
            if(error.error_code===6118 && error.message_local){
                this.time = parseInt(error.message_local);
                this.countDown(); 
            }else if(error.error_code == 1081){
              this.isRexImg = false;
              this.$refs.userInfo2.validateField('imgVerifyCode', valid => {
                  // console.log(valid,'imgVerifyCode')
                  return;
              })
            }else{
              this.$message.error(error.message_local ? error.message_local : this.errorCode[error.error_code]);
              // this.getImgVerifyCode();
              // this.$refs.imgVerify.focus();
              // this.userInfo2.imgVerifyCode ='';
              // if(error.error_code == 1083 || error.error_code == 1082){
              //   this.getImgVerifyCode();
              // }
            }
            
            if(error.error_code != 6118){
              this.$refs.imgVerify.focus();
              this.userInfo2.imgVerifyCode ='';
              this.getImgVerifyCode();
            }
        }
    },
    async countDown() {
      if (this.time == 0) {
        this.time = 60;
        // this.isVerified=false
        //   this.verifyParams={}
        //   this.$refs.verifyWrap.reload();
        return;
      } else {
        this.time--;
      }
      await this.sleep(1000);
      this.countDown();
    },
    //短信登陆
    async msLogin(){
      if(!this.isLogin){
        this.imgVerifyCode2 = '';
        this.verifycode2 = '';//清除自动填充内容
        this.$refs.userInfo2.validate(async valid => {
          if (valid) {
            // if(!this.isVerified){
            //   this.$message.error('请拖动滑块验证')
            // }else{
              let data = {
                mobile:this.userInfo2.telephone,
                captcha:this.userInfo2.verifycode
              };
              this.isLogin = true;
              try{
                const resp = await this.apiData('post', 'user/smsLogin',data);
                // 记住我功能
                this.keepPhone
                  ? cookieManager.setItem(config.cookie.smsLoginKey, this.userInfo2.telephone, 15)
                  : cookieManager.removeItem(config.cookie.smsLoginKey);

                this.setItem('local', 'twe_logged', resp.token);
                if(resp.needSetPwd){
                  this.$router.push('/setPassword');
                  this.setItem('local', 'setPwdUser', JSON.stringify({
                    email:resp.email
                  }));
                  this.isLogin = false;
                  return ;
                }
                const ret = await this.fetchAccount();
                this.removeItem('local', 'closeBroad');
                this.getBroadCast();
                this.RegistCall();
                installPermission(Vue, ret);
                window.sa.login(resp.userid);
                this.$store.commit('setClickNum', {
                  clickcontact_volume: resp.clickcontact_volume,
                  clickedContacts: resp.clickedContacts
                });
                this.$router.push({ path: getLoginIndex(resp.role) });
              }catch(error){
                this.$message.error(this.errorCode[error.error_code]);
              }
              this.isLogin = false;
            // }
          } else {
            return false;
          }
        });
      }
    },
    validatePhone2(rule, value, callback) {
      const regex = /^1\d{10}$/;
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else {
        if ( !regex.test(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
      }
    },
    validateVerifycode(rule, value, callback){
      if(this.verifycode2){ //自动填充不校验
        return;
      }
      if (value === '') {
        callback(new Error('请输入短信验证码'));
      } else {
        callback();
      }
    },
    validateImgVerify(rule, value, callback){
      if(this.imgVerifyCode2){
        return
      }
      if (value === '') {
        callback(new Error('请输入图片验证码'));
      } else {
        if (!this.isRexImg) {
          this.getImgVerifyCode(); //重新刷新验证码
          this.$refs.imgVerify.focus();
          this.userInfo2.imgVerifyCode = '';
          this.isRexImg = true;
          callback(new Error('请输入正确的图片验证码'));
          // this.userInfo2.imgVerifyCode = '';
        } else {
          callback();
        }
      }
    },
    addPlgin(){
      // 添加站点
    let d = document,
        y = null,
        x = null;
        y = d.getElementsByTagName('script')[0],
        x = d.createElement('script');
        x.src = this.addPlginValue
        x.setAttribute('data-visitor','visitor-identify')
        y.parentNode.insertBefore(x, y);
        window.sessionStorage.setItem('addPlginValue',this.addPlginValue)
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  .content {
    display: flex;
    flex-direction: row;
    .right {
      flex: auto;
      height: 100vh;
      position: relative;
      background: #ffffff;
      background: url('../assets/loginbg.png');
    }
  }
  .login-box {
    width: 1189px;
    height: 756px;
    border-radius: 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    background: url(../assets/loginframe1.png) no-repeat;
    .ms-login {
      padding: 0 72px;
      .user,
      .pwd {
        position: relative;
        i {
          position: absolute;
          display: block;
          left: 13px;
          top: 50%;
          width: 22px;
          height: 22px;
          margin-top: -10px;
          z-index: 201;
        }
      }
      .el-form-item__content{
        border: 1px solid red;
      }
    }
    .btn {
      padding: 0 72px 10px;
      margin-top: 60px;
      button {
        width: 100%;
        height: 58px;
        line-height: 58px;
        text-align: center;
        background: #41bfbf;
        color: #ffffff;
        font-size: 20px;
        border-radius: 4px;
        outline: none;
        cursor: pointer;
        border: none;
        &:disabled {
          opacity: 0.7;
          &:hover {
            cursor: not-allowed;
          }
        }
      }
    }
    .remember {
      font-size: 14px;
      color: #b2b2b2;
      padding: 0 72px;
      margin-bottom: 5px;
      margin-top: 5px;
      position: relative;
      & > span {
        position: absolute;
        right: 72px;
      }
      a {
        color: #359eff;
        margin-left: 5px;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .link{
      width: 120px;
      margin: 0;
      position: absolute;
      left: 50px;
      bottom: 80px;
      span{
        width: 87px;
        margin:0;
        position: absolute;
        top:19px;
        left: 5px;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;
        display: none;
      }
    }
    .link:hover{
      span{
        display: inline-block;
      }
    }
    .logo{
      width: 120px;
      margin: 0;
      position: absolute;
      left: 220px;
      top: 306px;
    }
    a#use,a#use1{
      color: #fff;
      text-decoration:none;
      margin:0;
      &:hover{
        color: #fff !important;
      }
    }
    .swipeWrapper,.speLink,.goNew{
      display: none;
    }
  }
  .login-form {
    width: 554px;
    height: 554px;
    position: absolute;
    right:41px;
    top: 110px;
    h3{
      line-height: 25px;
      text-align: center;
      margin-bottom: 14px;
      margin-left: 5px;
    }
    .title{
      color: #333;
      font-size: 20px;
      text-align: center;
      margin: 30px auto 36px;
      span{
        cursor: pointer;
      }
      span.active{
        color:#41bfbf;
      }
      .titleDash{
        margin:0 10px;
        color: #999;
        font-size:18px;
        vertical-align:1px;
      }
    }
    .speTitle span{
      cursor: default;
    }
  }
}
.dash{
  border-top:2px solid #e5e5e5 ;
  height: 0;
  width: 410px;
  margin:32px auto 30px ;
}
.changeCont{
  text-align: center;
  margin: 32px auto 0;
  width: 410px;
  font-size: 20px;
  color: #555;
  cursor: pointer;
  img{
    margin-right: 8px;
    margin-left: 5px;
  }
  span{
    vertical-align: 7px;
  }
}
.scanTitle{
  text-align: center;
  font-size: 22px;
  color: #333;
  img{
    margin-left: 10px;
  }
  span{
    vertical-align: 8px;
    margin-left: 6px;
  }
}
.loginTitle{
  text-align: left;
  font-size: 20px;
  color:#555;
  width: 410px;
  margin: 60px auto 30px;
}
.loginCompany{
  width: 410px;
  height: 52px;
  line-height: 52px;
  margin: 0 auto 30px;
  font-size: 16px;
  color:#333;
  border:1px solid #ccc;
  border-radius: 4px;
  padding-left: 30px;
  cursor: pointer;
  &.selected{
    border:1px solid #41bfbf;
    color:#41bfbf;
  }
}
.scanFoot{
  font-size: 16px;
  color: #333;
  position: absolute;
  right: 30px;
  bottom:-10px;
  cursor: pointer;
}
.err-msg {
  font-size: 12px;
  color: red;
  height: 17px;
  padding-left: 60px;
}
.fixedMsg{
  position: absolute;
  left:0;
  top:52px;
  padding-top: 4px;
  padding-left:0;
  color:#f56c6c;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #ffffff;
  z-index: 99;
  text-align: center;
  img {
    vertical-align: middle;
  }
  .kjnLoading{
    width: 100%;
    height: 100%;
    background: url('../assets/images/common/kjnBg.jpg') center no-repeat;
    text-align: center;
    .kjnLogo{
      margin-top: 320px;
    }
    .kjnTitle{
      font-size:18px;
      color:#00ffd8;
      margin-top: 35px;
      margin-bottom: 10px;
      opacity: 0.8;
    }
  }
}
.wrapper {
  .login-box {
    .ms-login {
      .user {
        i {
          background: url('../assets/images/common/Account.png') center no-repeat;
        }
      }
      .pwd {
        i {
          background: url('../assets/images/common/Lock.png') center no-repeat;
        }
      }
      .iphone {
        i {
          height: 26px;
          width: 20px;
          margin-top: -12px;
          background: url('../assets/images/common/Iphone.png') center no-repeat;
        }
      }
      .verifyCode {
        i {
          background: url('../assets/images/common/VerificationCode.png') center no-repeat;
        }
      }
    }
  }
}
.login-wrapper {
  min-width: 1280px;
}
.footer {
  position: absolute;
  bottom: 4px;
  text-align: center;
  width: 100%;
}
.footer .icp {
  color: #939393;
  margin: 0 auto;
  font-size: 12px;
  text-align: center;
  a {
    color: #939393;
    &:hover {
     color: #46c8c8;
    }
  }
}

.footer .gongan {
  width: 300px;
  margin: 0 auto;
  padding: 5px 0;
  font-size: 12px;
  p {
    color: #939393;
  }
  a:hover p {
    color: #46c8c8;
  }
}
.verifyButton{
  height:52px;
  text-align: center;
  line-height: 52px;
  border-radius:0 4px 4px 0;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  width: 132px;
  background: #41bfbf;
  margin-left: 16px;
  position: absolute;
  right:0;
  bottom: 0;
  &:hover{
    background: #3db3b3;
  }
  &.imgVerify{
    background: none;
    border-radius:0px 4px 4px 0px;
    // border:1px solid #dcdfe6;
    border-left: none;
    background-color: #EBFBFF;
    img{
      // padding: 6px;
      height: auto;
      width: 100%;
      border-radius: 0 4px 4px 0;
      vertical-align: middle;
    }
  }
  &.disabled{
    background:rgba(237,237,237,1);
    color: #BFBFBF;
  }
  &.refreshImg{
    color: #999;
    background: #FEEFEF;
    line-height: 0;
    padding: 8px;
    i{
      font-size: 18px;
      margin-bottom:4px;
    }
    p{
      font-size: 12px;
      line-height: 18px;
    }
  }
}
.timeButton{
  background: #ddd;
  color: #999;
  cursor: not-allowed;
  &:hover{
    background: #ddd;
  }
}
.goToNew{
  display: none;
}

/*带推广的登陆页面样式*/
.wrapper{
  .customLogin{
    .right {
      background: url('../../static/img/customLogin/customLoginBg.png');
    }
    .login-box{
      width: 1110px;
      height: 676px;
      background: #fff;
      box-shadow: 2px 0 20px 0 rgba(0,0,0,0.2);
      .link{
        display: none;
      }
      .login-form{
        top:70px;
        right: 0;
        .title{
          font-size: 18px;
          margin:18px auto 36px;
        }
        .btn{
          margin-top: 40px !important;
        }
        .remember{
          height: 18px !important;
        }
      }
      .swipeWrapper{
        display: block;
        width: 556px;
        height: 676px;
        position: absolute;
        left:0;
        top: 0;
        box-shadow:0 0 10px 0 rgba(0,0,0,0.2);
        .newsWrap{
          width: 556px;
          height: 70px;
          position: absolute;
          left: 0;
          bottom: 0;
          background:rgba(0,0,0,0.7);
          z-index: 999;
          color: #fff;
          .nt{
            display: inline-block;
            position: absolute;
            top:26px;
            left: 59px;
          }
          .circle{
            display: inline-block;
            height: 12px;
            width: 12px;
            background: #fff;
            border-radius: 100%;
            position: absolute;
            top:30px;
            left: 144px;
            label{
              position: absolute;
              top:1px;
              left:1px;
              display: inline-block;
              height: 10px;
              width: 10px;
              border: 1px solid #555;
              border-radius: 100%;
            }
          }
        }
        p{
          height: 70px;
          line-height: 70px;
          display: inline-block;
          color: #fff;
          margin-left: 175px;
          width: 325px;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          position: relative;
        }
        .newsSplitLine{
          display: none;
        }
        p:hover .newsSplitLine{
          width: 100%;
          margin:0;
          position: absolute;
          top:45px;
          left:0;
          border-bottom: 1px solid #fff;
          display: block;
        }
      }
      .speLink{
        width: 325px;
        display: block;
        padding-left: 72px;
        margin-top: 16px;
        color: #555;
        font-size: 14px;
        cursor: pointer;
        position: relative;
        label{
          color: #41bfbf;
          cursor: pointer;
        }
        span{
          display: none;
        }
        &:hover{
          span{
            width: 222px;
            margin:0;
            position: absolute;
            top:18px;
            left: 97px;
            border-bottom: 1px solid #999;
            display: block;
          }
        }
      }
      .goToNew{
        display: block;
        width: 400px;
        height:50px;
        margin:95px auto 0;
        text-align: center;
        &.distance-tip{
          margin-top:14px; 
        }
        p{
          font-size:16px;
          font-family:PingFang-SC-Medium;
          font-weight:500;
          color:rgba(128,128,128,1);
          margin-bottom: 20px;
          display: inline-block;
        }
        .goBtn{
          width:150px;
          height:28px;
          display: inline-block;
          border-radius:4px;
          font-size:16px;
          font-family:SourceHanSansCN-Normal;
          font-weight:400;
          color:rgba(65,191,191,1);
          line-height:26px;
          position: relative;
          span{
            cursor: pointer;
            width:100px;
            height: 100%;
            text-align: center;
            display: inline-block;
          }
          .goLogin{
            width: 45px;
          }
          .speLine1,.speLine2{
            display: none;
          }
          .goLogin:hover .speLine1,
          .goRegister:hover .speLine2{
              width: 40px;
              margin:0;
              position: absolute;
              top:23px;
              left:4px;
              border-bottom: 1px solid #41bfbf;
              display: block;
          }
          .goRegister:hover .speLine2{
            width: 70px;
            left:65px;
            top:23px;
          }
          .splitLine{
            position: absolute;
            top:-1px;
            left:50px;
            font-size:16px;
            display: inline-block;
          }
        }
      }
    }
  }
}
.customLogin h3 img{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue